import React from 'react'
import clsx from 'clsx'
import { useIntl } from 'react-intl'

import '../loader/style.css'
import './activityIndicator.css'

/**
 * Inline loading indicator (legacy name ActivityIndidicator). Used in modals, CustomDataList, side panels.
 * Visual matches `Loader` (brand navy + accent ring).
 */
function ActivityIndidicator({ showMessage = false, message, className, minimal = false }) {
  const { formatMessage: trans } = useIntl()
  const label = message ?? trans({ id: 'loading', defaultMessage: 'Loading...' })

  return (
    <div className={clsx('loader-root', minimal ? 't4i-activity-indicator--minimal' : 't4i-activity-indicator', className)} role="status" aria-live="polite" aria-busy="true" aria-label={label}>
      <div className="loader-content">
        <div className="loader-spinner" aria-hidden="true">
          <span className="loader-spinner__ring" />
          <span className="loader-spinner__ring loader-spinner__ring--accent" />
        </div>
        {showMessage ? <p className="loader-message">{label}</p> : null}
      </div>
    </div>
  )
}

export { ActivityIndidicator }
